import React from 'react';
import { Layout, InputNumber, Input } from 'antd';
import { translate } from 'react-i18next';
import i18next from 'i18next';
import { Helmet } from 'react-helmet';
import { CREATE_INCENTIVE_SUCCESS, UPDATE_INCENTIVE_SUCCESS, DELETE_INCENTIVE_SUCCESS } from '../../../campaign/campaignActions.js'
import { faTrash } from '@fortawesome/pro-light-svg-icons'

import GoalsPageEN from './locales/GoalsPage_en.json';
import GoalsPageFR from './locales/GoalsPage_fr.json';

import './GoalsPage.less';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class GoalsPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      
    };

    i18next.addResourceBundle('en', 'GoalsPage', GoalsPageEN);
    i18next.addResourceBundle('fr', 'GoalsPage', GoalsPageFR);

    this.save = this.save.bind(this);
    this.delete = this.delete.bind(this);
    this.addIncentive = this.addIncentive.bind(this);
  }

  save(id) {
    let goal = document.getElementById('goal_' + id).value;
    let desc = document.getElementById('desc_' + id).value;

    this.props.updateIncentive(this.props.campaign.id, id, this.props.locale, goal, desc).then((e) => {
        if(e.type === UPDATE_INCENTIVE_SUCCESS) {
            this.props.fetchIncentives(this.props.campaign.id);
        }
    });
  }

  delete(id) {
    this.props.deleteIncentive(this.props.campaign.id, id).then((e) => {
        if(e.type === DELETE_INCENTIVE_SUCCESS) {
            this.props.fetchIncentives(this.props.campaign.id);
        }
    });
  }

  addIncentive() {
    this.props.createIncentive(this.props.campaign.id, this.state.newIncentiveGoal, this.state.newIncentiveDesc).then((e) => {
        if(e.type === CREATE_INCENTIVE_SUCCESS) {
            this.props.fetchIncentives(this.props.campaign.id);
        }
    })
  }

  render() {
    const { t, incentives, campaign } = this.props;

    return (
      <Layout className="GoalsPage">
        <Helmet>
          <title>{t('Goals')}</title>
        </Helmet>

        <div class="dashContent overview">
            <section class="title">
                <div class="greetings">
                    <h1>{t('incentives')}</h1>
                </div>
            </section>

            <div class="editZone js-sticky-base">
                <div class="contentZone">
                    <h2>{t('incentive_title')}</h2>
                    <div class="chunk">
                        <p>{t('incentive_subtitle')}</p>

                        {incentives.length < 1 ?
                            <p>{t('incentive_nothing_yet')}</p>
                        :
                            <div class="incentivesEdit addincentivesOption">
                                <div class="amount"><span class="row_title">{t('incentive_amount')}</span></div>
                                <div class="description"><span class="row_title">{t('incentive_description')}</span></div>
                                <div class="button"></div>
                                {incentives.map((i) => {
                                    return (<>
                                        <div key={i.id + '_' + this.props.locale + "_amount"} class="amount">
                                            <InputNumber id={'goal_' + i.id} placeholder={t('incentive_amount')} className="incentive_amount" defaultValue={i.goal} required />
                                        </div>
                                        <div key={i.id + '_' + this.props.locale + "_description"} class="description">
                                            <Input id={'desc_' + i.id} type="text" placeholder={t('incentive_description')} className="incentive_description" 
                                            defaultValue={i.description.description} required />
                                        </div>
                                        <div class="buttons">
                                            <FontAwesomeIcon className='edit-icon' onClick={() => {this.save(i.id)}} icon={['fal', 'save']}/>
                                            <FontAwesomeIcon className='delete-icon' onClick={() => {this.delete(i.id)}} icon={faTrash}/>
                                        </div></>
                                    )
                                })}
                            </div>
                        }
                        <div class="addincentivesOption js-add-incentives-option">
                            <h3 class="header">{t('incentive_title_new')}</h3>
                            <div class="amount">
                                <InputNumber name="amount" placeholder={t('incentive_amount')} className="incentive_amount" value={this.state.newIncentiveGoal}
                                onChange={(e) => {this.setState({newIncentiveGoal: e})}}/>
                            </div>
                            <div class="description">
                                <Input type="text" name="desc" placeholder={t('incentive_description')} className="incentive_description" 
                                onChange={(e) => {this.setState({newIncentiveDesc: e.target.value})}} value={this.state.newIncentiveDesc}/>
                            </div>
                            <div class="buttons">
                                <button type="submit" onClick={this.addIncentive} 
                                class="ant-btn FundkyButton FundkyButton__Type--primary FundkyButton__Size--medium apply ant-btn-primary">
                                    {t('incentive_cta_add')}
                                </button>
                            </div>
                            <p class="incentive_example">{t('incentive_example')}</p>
                        </div>

                    </div>

                </div>

            </div>

        </div>
      </Layout>
    );
  }
}

GoalsPage.defaultProps = {
  incentives: []
};

export default translate('GoalsPage')(GoalsPage);
